export default {
  "de-DE": {
    "wallpaper.text001": "Vielen Dank für deine Wahl!",
    "wallpaper.text002": "Dein Hintergrundbild steht bereit.",
    "wallpaper.text003": "Tippe auf das obige Bild, um den Hintergrund anzuzeigen, und lade das Bild herunter.",
    "connect.text001": "Für den Zugang zu deiner Heldenliste musst du dich bei deinem Nintendo-Account anmelden.",
    "connect.text002": "Melde dich bei deinem Nintendo-Account an, um:",
    "connect.text003": "100 Platinpunkte für My Nintendo zu erhalten!",
    "connect.text004": "Den Verlauf deiner Heldenwahl in deiner Heldenliste einzusehen!",
    "connect.text005": "Wähle mindestens 3-mal für ein besonderes Hintergrundbild!",
    "connect.text006": "Was ist My Nintendo?",
    "connect.btn001": "Anmelden und einen Helden wählen",
    "connect.btn002": "Wählen ohne Anmeldung",
    "connect.btn003": "Anmelden",
    "connect.btn004": "Nicht anmelden",
    "confirm.btn001": "Nein",
    "confirm.btn002": "Ja",
    "confirm.text001": "Diesen Helden wählen?"
  },
  "en-GB": {
    "wallpaper.text001": "Thanks for making a choice!",
    "wallpaper.text002": "Your wallpaper is ready.",
    "wallpaper.text003": "Tap the image above to display the wallpaper, then save the image to your device.",
    "connect.text001": "You must sign in to your Nintendo Account to access your Battle Ballot.",
    "connect.text002": "Sign in to your Nintendo Account to",
    "connect.text003": "Get 100 Platinum Points for My Nintendo",
    "connect.text004": "Review your Hero selection history from your Battle Ballot!",
    "connect.text005": "Vote three or more times to receive special wallpaper!",
    "connect.text006": "What is My Nintendo?",
    "connect.btn001": "Sign in and choose a Hero",
    "connect.btn002": "Choose without signing in to account",
    "connect.btn003": "Sign In",
    "connect.btn004": "Don't Sign In",
    "confirm.btn001": "No",
    "confirm.btn002": "Yes",
    "confirm.text001": "Choose this Hero?"
  },
  "es-ES": {
    "wallpaper.text001": "¡Gracias por participar!",
    "wallpaper.text002": "Tu fondo de pantalla está listo.",
    "wallpaper.text003": "Toca la imagen de arriba para ver el fondo de pantalla y guárdalo en tu dispositivo.",
    "connect.text001": "Debes iniciar sesión con tu cuenta Nintendo para acceder a tu registro.",
    "connect.text002": "Inicia sesión con tu cuenta Nintendo y podrás:",
    "connect.text003": "conseguir 100 puntos de platino en My Nintendo;",
    "connect.text004": "consultar en tu registro los héroes que has elegido, y",
    "connect.text005": "hacerte con fondos de pantalla especiales al votar 3 veces o más.",
    "connect.text006": "¿Qué es My Nintendo?",
    "connect.btn001": "Iniciar sesión y elegir a un héroe",
    "connect.btn002": "Elegir sin iniciar sesión",
    "connect.btn003": "Iniciar sesión",
    "connect.btn004": "No iniciar sesión",
    "confirm.btn001": "No",
    "confirm.btn002": "Sí",
    "confirm.text001": "¿Elegir este héroe?"
  },
  "fr-FR": {
    "wallpaper.text001": "Merci d'avoir voté !",
    "wallpaper.text002": "Votre fond d'écran est prêt.",
    "wallpaper.text003": "Touchez l'image ci-dessus pour afficher le fond d'écran, puis enregistrez l'image sur votre appareil.",
    "connect.text001": "Vous devez vous connecter à votre compte Nintendo pour accéder à votre historique.",
    "connect.text002": "Se connecter à votre compte Nintendo<br>permet de :",
    "connect.text003": "Recevoir 100 points platine pour My Nintendo",
    "connect.text004": "Consulter le récapitulatif de vos votes",
    "connect.text005": "Recevoir un fond d'écran spécial si vous votez au moins trois fois",
    "connect.text006": "Qu'est-ce que My Nintendo ?",
    "connect.btn001": "Se connecter et voter",
    "connect.btn002": "Voter sans se connecter",
    "connect.btn003": "Se connecter",
    "connect.btn004": "Ne pas se connecter",
    "confirm.btn001": "Non",
    "confirm.btn002": "Oui",
    "confirm.text001": "Choisir ce héros ?"
  },
  "it-IT": {
    "wallpaper.text001": "Grazie per aver partecipato!",
    "wallpaper.text002": "Uno sfondo è pronto per te.",
    "wallpaper.text003": "Tocca l'immagine qui sopra per mostrare il tuo sfondo, poi salvalo sul dispositivo.",
    "connect.text001": "Devi usare il tuo account Nintendo per accedere alla tua Lista scelte.",
    "connect.text002": "Accedi al tuo account Nintendo per:",
    "connect.text003": "Ricevere 100 punti di platino per My Nintendo",
    "connect.text004": "Rivedere la cronologia di selezione eroi da Lista scelte!",
    "connect.text005": "Votare 3 volte o più e ricevere uno sfondo speciale!",
    "connect.text006": "Che cos'è My Nintendo?",
    "connect.btn001": "Accedi e scegli un eroe",
    "connect.btn002": "Scegli senza accedere all'account",
    "connect.btn003": "Accedi",
    "connect.btn004": "Non accedere",
    "confirm.btn001": "No",
    "confirm.btn002": "Sì",
    "confirm.text001": "È questa la tua scelta?"
  },
  "ja-JP": {
    "wallpaper.text001": "おめでとうございます！",
    "wallpaper.text002": "オリジナル壁紙を獲得しました！",
    "wallpaper.text003": "上の画像をタップ（クリック）して<br>お使いの端末の方法に従って<br>画像を保存してください。",
    "connect.text001": "マイページを利用するにはニンテンドーアカウントへのログインが必要です",
    "connect.text002": "ニンテンドーアカウントでログインすると",
    "connect.text003": "100プラチナコインをプレゼント！",
    "connect.text004": "マイページで投票履歴を確認できる！",
    "connect.text005": "3回以上投票でオリジナル壁紙がもらえる！",
    "connect.text006": "マイニンテンドーとは？",
    "connect.btn001": "ログインして投票する",
    "connect.btn002": "ログインせずに投票する",
    "connect.btn003": "ログインする",
    "connect.btn004": "ログインしない",
    "confirm.btn001": "いいえ",
    "confirm.btn002": "はい",
    "confirm.text001": "に投票しますか？"
  },
  "zh-TW": {
    "wallpaper.text001": "恭喜您！",
    "wallpaper.text002": "獲得了原創桌布！",
    "wallpaper.text003": "請點觸（點擊）上方的圖像，<br>並依照各機種的操作方法<br>保存圖像。",
    "connect.text001": "進入「My Page」前，需登入Nintendo Account。",
    "connect.text002": "使用Nintendo Account登入",
    "connect.text003": "可以獲得100點白金點數！",
    "connect.text004": "可以在「My Page」確認投票紀錄！",
    "connect.text005": "投票次數達3次以上即可獲得原創桌布！",
    "connect.text006": "My Nintendo是什麼？",
    "connect.btn001": "登入並進行投票",
    "connect.btn002": "不登入直接進行投票",
    "connect.btn003": "登入",
    "connect.btn004": "不登入",
    "confirm.btn001": "不是",
    "confirm.btn002": "是",
    "confirm.text001": "投此角色一票？"
  },
  "en-US": {
    "wallpaper.text001": "Thanks for making a choice!",
    "wallpaper.text002": "Your wallpaper is ready.",
    "wallpaper.text003": "Tap the image above to display the wallpaper, then save the image to your device.",
    "connect.text001": "You must sign in to your Nintendo Account to access your Battle Ballot.",
    "connect.text002": "Sign in to your Nintendo Account to",
    "connect.text003": "Get 100 Platinum Points for My Nintendo",
    "connect.text004": "Review your Hero selection history from your Battle Ballot!",
    "connect.text005": "Vote three or more times to receive special wallpaper!",
    "connect.text006": "What is My Nintendo?",
    "connect.btn001": "Sign in and choose a Hero",
    "connect.btn002": "Choose without signing in to account",
    "connect.btn003": "Sign In",
    "connect.btn004": "Don't Sign In",
    "confirm.btn001": "No",
    "confirm.btn002": "Yes",
    "confirm.text001": "Choose this Hero?"
  },
  "es-MX": {
    "wallpaper.text001": "¡Gracias por participar!",
    "wallpaper.text002": "Tu fondo de pantalla está listo.",
    "wallpaper.text003": "Toca la imagen de arriba para ver el fondo de pantalla y guárdalo en tu dispositivo.",
    "connect.text001": "Debes iniciar la sesión con tu cuenta Nintendo para acceder a tu boleta.",
    "connect.text002": "Inicia sesión con tu cuenta Nintendo y podrás:",
    "connect.text003": "Conseguir 100 puntos de platino en My Nintendo.",
    "connect.text004": "Consultar en tu boleta los héroes que elegiste.",
    "connect.text005": "Conseguir fondos de pantalla especiales al votar 3 veces o más.",
    "connect.text006": "¿Qué es My Nintendo?",
    "connect.btn001": "Iniciar sesión y elegir a un héroe",
    "connect.btn002": "Elegir sin iniciar sesión",
    "connect.btn003": "Iniciar sesión",
    "connect.btn004": "No iniciar sesión",
    "confirm.btn001": "No",
    "confirm.btn002": "Sí",
    "confirm.text001": "¿Elegir este héroe?"
  },
  "fr-CA": {
    "wallpaper.text001": "Merci d'avoir voté!",
    "wallpaper.text002": "Votre fond d'écran est prêt.",
    "wallpaper.text003": "Touchez l'image ci-dessus pour afficher le fond d'écran, puis enregistrez l'image sur votre appareil.",
    "connect.text001": "Vous devez vous connecter à votre compte Nintendo pour accéder à votre historique.",
    "connect.text002": "Se connecter à votre compte Nintendo<br>permet de :",
    "connect.text003": "Recevoir 100 points platine pour My Nintendo",
    "connect.text004": "Consulter le récapitulatif de vos votes",
    "connect.text005": "Recevoir un fond d'écran spécial si vous votez au moins trois fois",
    "connect.text006": "Qu'est-ce que My Nintendo?",
    "connect.btn001": "Se connecter et voter",
    "connect.btn002": "Voter sans se connecter",
    "connect.btn003": "Se connecter",
    "connect.btn004": "Ne pas se connecter",
    "confirm.btn001": "Non",
    "confirm.btn002": "Oui",
    "confirm.text001": "Choisir ce héros?"
  },
  "pt-BR": {
    "wallpaper.text001": "Agradecemos o seu voto!",
    "wallpaper.text002": "O seu papel de parede está pronto.",
    "wallpaper.text003": "Toque na imagem acima para exibir o papel de parede e salvá-lo no seu dispositivo.",
    "connect.text001": "É necessário fazer o login na sua conta Nintendo para acessar a sua cédula.",
    "connect.text002": "Faça o login na sua conta Nintendo para:",
    "connect.text003": "Receber 100 pontos de platina My Nintendo;",
    "connect.text004": "Consultar em quais heróis você votou no passado;",
    "connect.text005": "Votar três ou mais vezes para receber papéis de parede especiais!",
    "connect.text006": "O que é My Nintendo?",
    "connect.btn001": "Faça o login e escolha um herói",
    "connect.btn002": "Escolha um herói sem fazer o login",
    "connect.btn003": "Fazer login",
    "connect.btn004": "Não fazer o login",
    "confirm.btn001": "Não",
    "confirm.btn002": "Sim",
    "confirm.text001": "Escolher este herói?"
  }
}